import { logoHorizontal as g, logoMini as A } from "./assets/index.js";
import { j as t } from "./toast-container-B09_bbj7.js";
import { A as R, B as x, C as B, I as T, e as _, b as D, L as N, P as h, c as y, R as L, a as v, S as w, T as M, d as k, f as J, h as j, g as z, i as G, u as Y } from "./toast-container-B09_bbj7.js";
import { u as U, a as V } from "./usePopupPosition-DLTzt-Ua.js";
import { u as F } from "./useClickAway-B02nPhI9.js";
import { jsx as i } from "react/jsx-runtime";
import { createContext as u, use as d, useState as c, useMemo as l, useEffect as I } from "react";
import { CSVDownloader as Q, deepCopy as W, formatCurrency as X, formatText as Z, timestampConvertor as $ } from "./utils/index.js";
import { o as et, a as at } from "./events-DamQnLE5.js";
const r = u({
  sidebarStatus: t.OPEN_SIDEBAR,
  handleSidebarStatus: (s) => {
  }
}), E = () => d(r), b = (s) => {
  const [o, a] = c(
    t.OPEN_SIDEBAR
  ), n = l(() => o, [o]), S = (e) => {
    switch (e) {
      case t.OPEN_SIDEBAR:
        return localStorage.setItem("sidebarStatus", JSON.stringify(e)), a(t.OPEN_SIDEBAR);
      case t.CLOSE_SIDEBAR:
        return localStorage.setItem("sidebarStatus", JSON.stringify(e)), a(t.CLOSE_SIDEBAR);
      case t.TEMPORARILY_OPEN_SIDEBAR:
        return localStorage.setItem("sidebarStatus", JSON.stringify(e)), a(
          t.TEMPORARILY_OPEN_SIDEBAR
        );
      default:
        return a(t.OPEN_SIDEBAR);
    }
  };
  return I(() => {
    const e = localStorage.getItem("sidebarStatus");
    e && a(JSON.parse(e));
  }, []), /* @__PURE__ */ i(
    r.Provider,
    {
      value: {
        sidebarStatus: n,
        handleSidebarStatus: S
      },
      children: s.children
    }
  );
};
export {
  R as ArrowheadDownIcon,
  x as Button,
  Q as CSVDownloader,
  B as CheckBox,
  T as IconButton,
  _ as Input,
  D as Loader,
  N as LogoutOutlineIcon,
  h as PageContainer,
  y as PageSearchInput,
  L as RepeatIcon,
  b as SidebarStatusProvider,
  v as SparklesGradientIcon,
  w as SparklesIcon,
  M as TableGenerator,
  k as TableOptions,
  J as ToastContainer,
  j as ToastContext,
  z as ToastMessage,
  G as ToastProvider,
  W as deepCopy,
  X as formatCurrency,
  Z as formatText,
  g as logoHorizontal,
  A as logoMini,
  et as off,
  at as on,
  $ as timestampConvertor,
  U as useBeforeUnload,
  F as useClickAway,
  V as usePopupPosition,
  E as useSidebarStatusContext,
  Y as useToast
};
//# sourceMappingURL=index.js.map
